import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite'; 
import { ctrl  } from './controller'; 
import SiteBreadcrumb from '@/components/SiteBreadcrumb';
import './index.less';  
import { useNavigate } from 'react-router-dom';
import { globalStore } from '@/common';
import LoadingPlaceholder from '@/components/LoadingPlaceholder';
import { Card } from 'antd'; 
import { projectPageModel } from './model';
import Filter from './parts/Filter';
import List from './parts/List';

const View: React.FC = observer(() => {

  useEffect(() => {
    ctrl.initialize();
  }, []);

  const navigate = useNavigate();

  if (globalStore.sessionChecked && !globalStore.isLogin) {
    navigate('/login');
  }

  if ( !globalStore.isLoaded || ! projectPageModel.isLoaded) {
    return <LoadingPlaceholder />;
  }
 
 
  return (
    <div className='project-page'> 
        <SiteBreadcrumb name="项目管理" />
        <Card>
          <Filter currentUser={globalStore.currentUser} model={projectPageModel}></Filter>
          <List  list={projectPageModel.filteredList}></List>
        </Card>
    </div> 
  );
}); 
export default View;
